import React from 'react';
import { VODCSSModules } from 'shared/utils/wix-connect';

import PropTypes from 'prop-types';

import withTooltip, { adaptShowStatePropsToClassName } from 'shared/components/with-tooltip/with-tooltip';

import styles from './icon.styl';
import fontelloIconsStyles from 'shared/fontello/css/fontello-codes.css';


@VODCSSModules({ ...styles, ...fontelloIconsStyles })
export default class Icon extends React.PureComponent {

  static propTypes = {
    size: PropTypes.number,
    name: PropTypes.string,
    className: PropTypes.string,
    getRef: PropTypes.func,
  };

  static defaultProps = {
    getRef: _.noop,
  };

  get iconStyle() {
    const { size } = this.props;
    if (!size) {
      return null;
    }

    return {
      fontSize: size,
    };
  }

  render() {
    const { name, getRef } = this.props;
    const props = _.omit(this.props, [
      'styles', 'styleName', 'intl', 'settings', 'getRef',
      'biEvent', 'biError', 'closePortal', 'children',
    ]);

    return (
      <span ref={getRef}
            styleName={`icon icon--${name}`}
            {...props}
            style={this.iconStyle} />
    );
  }
}


@VODCSSModules(styles)
export class RoundedIcon extends React.PureComponent {
  render() {
    const props = _.omit(this.props, 'styles');

    return (
      <Icon {...props}
            styleName="rounded-icon" />
    );
  }
}

export const TooltipIcon = withTooltip(adaptShowStatePropsToClassName(Icon));
export const TooltipRoundedIcon = withTooltip(adaptShowStatePropsToClassName(RoundedIcon));



// WEBPACK FOOTER //
// ./src/shared/components/icon/icon.js